document.documentElement.classList.remove('no-js');

const colorMap = {
  black: '#1d1d1b', midnight: '#141518', midnightblack: '#141518', white: '#f7f4ee', sand: '#b7a68a', sandgreen: '#8f9a72', luminousgreen: '#b4c83e', green: '#77865a', blushpink: '#e3a9ad', pink: '#e5afb3', coralpink: '#e99a8b', lavender: '#a7a1cf', lavendar: '#a7a1cf', purplelavendar: '#9e82b0', skyblue: '#93b8ce', dustblue: '#7a9eb6', lightgrey: '#bcbcc0', grey: '#a2a1a0', orange: '#dd783f', red: '#a72628', lime: '#b6c838'
};

function normalizeColor(value) {
  return value.toLowerCase().replace(/[^a-z]/g, '');
}

document.querySelectorAll('[data-swatch-color]').forEach((dot) => {
  dot.style.setProperty('--swatch-color', colorMap[normalizeColor(dot.dataset.swatchColor)] || '#c9c1b6');
});

document.querySelectorAll('[data-mobile-menu-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const menu = document.querySelector('[data-header-menu]');
    if (!menu) return;
    menu.classList.toggle('is-open');
    button.setAttribute('aria-expanded', String(menu.classList.contains('is-open')));
  });
});

function money(cents, format) {
  const amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString());
}

document.querySelectorAll('[data-product-picker]').forEach((picker) => {
  const dataNode = document.querySelector('[data-product-json]');
  if (!dataNode) return;
  const variants = JSON.parse(dataNode.textContent);
  const form = picker.querySelector('[data-product-form]');
  const idInput = form?.querySelector('[name="id"]');
  const priceEl = picker.querySelector('[data-product-price]');
  const availability = picker.querySelector('[data-stock-note]');
  const addButton = picker.querySelector('[data-add-button]');
  const notify = picker.querySelector('[data-back-in-stock]');
  const notifyDetails = picker.querySelector('[data-notify-details]');
  const moneyFormat = picker.dataset.moneyFormat || '${{amount}}';
  const media = picker.querySelectorAll('[data-media-id]');

  const readVariant = () => {
    const options = [...picker.querySelectorAll('[data-option-index]')].reduce((selected, input) => {
      if (input.checked) selected[Number(input.dataset.optionIndex)] = input.value;
      return selected;
    }, []);
    return variants.find((variant) => variant.options.every((option, index) => option === options[index]));
  };

  const update = () => {
    const variant = readVariant();
    if (!variant) {
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = 'Unavailable';
      }
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price, moneyFormat);
    if (availability) {
      availability.textContent = variant.available ? 'In stock — ready to move with you.' : 'This selection is currently sold out.';
      availability.classList.toggle('is-soldout', !variant.available);
    }
    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to bag' : 'Sold out';
    }
    if (notify) notify.classList.toggle('hidden', variant.available);
    if (notifyDetails) notifyDetails.value = `Please notify me when ${picker.dataset.productTitle} — ${variant.title} is back in stock.`;
    if (variant.featured_media?.id) {
      media.forEach((item) => item.classList.toggle('hidden', String(item.dataset.mediaId) !== String(variant.featured_media.id)));
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  picker.querySelectorAll('[data-option-index]').forEach((input) => input.addEventListener('change', update));
  update();
});
